export default "__VITE_ASSET__CJApPY0Y__"